// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleRelatedContentModule_root__1MN9q","notchedModule":"ArticleRelatedContentModule_notchedModule__EW8zS"};